import * as React from 'react';
import { ToggleInput, IToggleInputProps } from '@agilepoint/wat-react-ux';
import { Controller, useFormContext, UseControllerReturn } from 'react-hook-form';
import { IBaseFormFieldProps } from './types';

export interface IToggleInputFormFieldProps extends Omit<IBaseFormFieldProps, 'label' | 'orientation' | 'gap'>, Omit<IToggleInputProps, 'name' | 'key'> {
}

export function ToggleInputField(props: IToggleInputFormFieldProps) {
    const { className, name, defaultChecked, onValueChange, validationRules, ...restProps } = props;
    const { control } = useFormContext();

    const renderToggleInput = React.useCallback(({ field: { onChange, onBlur, value } }: UseControllerReturn) => (
        <ToggleInput {...restProps} onValueChange={onChange} checked={value} onBlur={onBlur} />
    ), [restProps]);

    return (
        <div className={className}>
            <Controller control={control} defaultValue={defaultChecked} rules={validationRules} name={name}
                render={renderToggleInput} />
        </div>
    );
}
